import React from 'react'

import { StyledEditor } from './TextEditorOutput.styles'
import type { TextEditorOutputProps } from './TextEditorOutput.types'
import { sanitizeTextEditorHtml } from './TextEditorOutput.utils'

/**
 * Render formatted text from `TextEditor`
 *
 * @since 10.24.0
 */
export const TextEditorOutput = React.forwardRef<
  HTMLDivElement,
  TextEditorOutputProps & React.HTMLAttributes<HTMLDivElement>
>(function TextEditorOutput({ value, ...props }, ref) {
  const sanitizedHtml = sanitizeTextEditorHtml(value || '--')

  return (
    <StyledEditor {...props} ref={ref}>
      <div
        className="ck-content"
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        contentEditable={false}
      />
    </StyledEditor>
  )
})

TextEditorOutput.displayName = 'TextEditorOutput'
